
const state = {
  device: 'desktop'
}

const mutations = {
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
    // console.log("==========")
    // console.log(state.device)
  }
}

const actions = {
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
